import React, { useState } from 'react'
import { Widget } from 'features/types'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { SocialWebPopularPostsWidget as SocialWebPopularPostsWidgetType } from 'schemas/SocialWebPopularPostsWidgetSchema'
import { getLabel } from 'utils/widgetTypeUtil'

import { PreSearchGuard } from './guards'
import RunSearchEffect from './RunSearchEffect'
import PostSearchGuard from './guards/PostSearchGuard'
import PopularPosts from './PopularPosts'
import InsightModal from './PopularPosts/InsightModal'
import { useSelectedInsights } from './PopularPosts/hooks'

const SocialWebPopularPostsWidget: Widget = ({ widgetId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const widgetSetting = useDashboardWidgetSetting<SocialWebPopularPostsWidgetType>(widgetId)
  const { detailSetting, handleRowClick, widgetSettingWithSelection } = useSelectedInsights(
    isModalOpen,
    widgetSetting,
    setIsModalOpen
  )

  return (
    <UnexpectedErrorBoundary>
      <PreSearchGuard widgetId={widgetId}>
        <RunSearchEffect widgetId={widgetId}>
          <PostSearchGuard widgetId={widgetId}>
            <PopularPosts widgetId={widgetId} onRowClick={handleRowClick} />
          </PostSearchGuard>
        </RunSearchEffect>
      </PreSearchGuard>
      <InsightModal
        widgetSettingWithSelection={widgetSettingWithSelection}
        open={isModalOpen}
        title={widgetSetting?.name || getLabel(widgetSetting?.type)}
        onClose={() => {
          setIsModalOpen(false)
        }}
        detailSetting={detailSetting}
      />
    </UnexpectedErrorBoundary>
  )
}

export default SocialWebPopularPostsWidget
